__turbopack_context__.v({
  "footerLink": "FooterLink-module-scss-module__3Q8hrG__footerLink",
});
